//export const phoneRegExp = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/;
//export const phoneRegExp = /^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/;
// export const phoneRegExp = /^\+?\d{7,}$/;
// export const phoneRegExp = /^(?:\s*\+)?[\d\s\.\-]+$/;
export const phoneRegExp = /^\+?(?:[\s(-]*\d[\s)-]*){10,}$/;

//export const phoneRegexpReplace = /[^\+?\d\s]+/g
export const phoneRegexpReplace = /[^\+?\d\s(?)?]+/g

/**
 * used by main site to check if the account is logged in
 * @param loggedIn
 */
export const setLoggedInFlag = (loggedIn) => {

    if(loggedIn) {
        localStorage.setItem('bySignedIn', 'active');
    }
    else {
        localStorage.removeItem('bySignedIn');
    }
}